export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-v1-480-d191f6f5e3392df291081b4d6d696df6.webp";